export function objectToFiltersQuery(obj?: Record<string, any>): string {
    if(!obj) return '';
    const params = new URLSearchParams();

    Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
            return;
        }
        if (Array.isArray(value)) {
            params.append(key, value.join(','));
        } else {
            params.append(key, String(value));
        }
    });

    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
}